
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefits/networking",
      function () {
        return require("private-next-pages/benefits/networking/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefits/networking"])
      });
    }
  